import { useEffect, useState } from "react";
import { Tab, Tabs } from "@mui/material";
import CertificateContainer from "../../containers/CertificateContainer";
import { getQueryObject } from "../../helpers/urlBuilder";
import { useNavigate } from "react-router-dom";
import { createCertainCertificateLink } from "../../pages";

import classes from './index.module.scss';

const CertificateTabs = () => {
  const query = getQueryObject();
  const navigate = useNavigate();
  const { type = 1 } = query;
  const [selectedTab, setSelectedTab] = useState(type);

  useEffect(() => {
    setSelectedTab(type);
  }, [type])

  const onTabSelected = (e, id) => {
    const url = createCertainCertificateLink(id);
    navigate(url);
    setSelectedTab(id);
  }

  return (
    <>
      <Tabs value={selectedTab} onChange={onTabSelected} className={classes.tabs}>
        <Tab label="GHMT Type Approval" value={1}></Tab>
        <Tab label="GHMT PREMIUM Verification Program" value={2}></Tab>
      </Tabs>
      {
        selectedTab === 1 ? (
          <CertificateContainer type={CertificateContainer.TYPES.APPROVAL} />
        ) : null
      }
      {
        selectedTab === 2 ? (
          <CertificateContainer type={CertificateContainer.TYPES.PREMIUM} showCompanyLink />
        ) : null
      }
    </>
  )
}

export default CertificateTabs;